//NOTE: Migrate to use Base instead of BaseLegacy and remove legacy type when possible.
export interface BaseLegacy {
	Id: number;
	Name: string;
	IsActive: boolean;
}

export interface Base {
	id: number;
	name: string;
	isActive: boolean;
}

export interface BizObject extends BaseLegacy {
	ObjectType: ObjectType;
}

export interface KeyValueEntity {
	Key: string;
	Value: string | undefined;
}

export enum ObjectType {
	None = 0,
	CMSPage = 100,
	BlogPost = 101,
	OnlineEducation = 102,
	GenericTag = 103,
	Certification = 104,
	Event = 105,
	EngagementGoal = 200,
	EngagementActivity = 201,
	EngagementTodo = 202,
	MediabankFile = 300,
	User = 400,
	UserAdminFiles = 401,
	Unit = 500,
	FrontEndObject = 600,
	Document = 700,
	DocumentCategory = 701,
	DocumentCategoryFile = 702,
	DocumentOriginalFile = 703,
	DocumentContentFile = 704,
	DocumentAttachedFile = 705,
	ChatRoom = 800,
	Whiteboard = 900,
	Quiz = 1000,
	Poll = 1001,
	Comment = 1002,
	Badge = 1100,
	Journey = 1200,
	SourceKnowledgeSource = 1300,
	SourceKnowledgeUnit = 1301,
	CheckIn = 1400,
	TimeReportExpense = 1500,
	ProjectTask = 99990,
}
export interface ResponseStatus {
	Success: boolean;
	Message?: string;
	ObjectId?: number;
	Object?: unknown;
	ExtraInfo?: unknown;
}

export type LinkedObject = {
	ObjectType: ObjectType;
	ObjectId: number;
};

export enum LayoutComponent {
	None = 0,
	Header = 1,
	Body = 2,
	Footer = 3,
	Login = 4,
	CookieInformation = 5,
	WelcomeGuide = 6,
	PrivacyPolicy = 7,
	WelcomeGuideAdmin = 8,
	GenericGuide = 9,
	CookiePolicy = 10,
}
